import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import HomeView from './views/HomeView';
import WatchedStocksView from './views/WatchedStocksView';
import PortfolioView from './views/PortfolioView';
import SpendView from './views/SpendView';
import BoutiquesView from './views/BoutiquesView';
import BoutiqueDetailsView from './views/BoutiqueDetailsView';
import ErrorPage from './views/ErrorPage';
import LoginModal from './components/LoginModal';
import AuthBootstrap from './components/AuthBootstrap';

const App: React.FC = () => {
    return (
        <>
            <AuthBootstrap />
            <Router>
                <Routes>
                    <Route path="/" element={<HomeView />} />
                    <Route path="/watched-stocks" element={<WatchedStocksView />} />
                    <Route path="/portfolio" element={<PortfolioView />} />
                    <Route path="/spend" element={<SpendView />} />
                    <Route path="/boutiques" element={<BoutiquesView />} />
                    <Route path="/boutiques/:boutiqueId" element={<BoutiqueDetailsView />} />
                    <Route path="*" element={<ErrorPage />} />
                </Routes>
            </Router>
            <LoginModal />
        </>
    );
};

export default App; 